import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { App } from '@df/core/app';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';
import { Section2Component } from '../../common/section2/section2.component';
import { AccountBackComponent } from '../back/account-back.component';

export namespace NStockLevelComponent {
    export const componentId = 'account-stock-level';

    export interface IComponentData {
        items: IItem[];
    }

    export interface IItem {
        title: string;
        description?: string;
        links?: ILink[];
        displayButtton?: boolean;
    }

    export interface ILink {
        linkText: string;
        url: string;
    }
}

@Component({
    selector: 'account-stock-level-report',
    templateUrl: './account-stock-level-report.html',
    styleUrls: ['./account-stock-level-report.scss'],
    standalone: true,
    imports: [AccountBackComponent, TranslationModule, Section2Component, ICmsClientModule, HrefComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<AccountStockLevelReportComponent>({
    id: NStockLevelComponent.componentId,
    block: {
        url: NStockLevelComponent.componentId
    },
    onDemandOnly: true,
    name: 'Account Stock Level',
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Items',
            itemNameField: 'title',
            itemName: 'Item',
            required: true,
            fields: [
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.textarea,
                    key: 'description',
                    title: 'Description'
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'links',
                    title: 'Links',
                    itemName: 'Link',
                    itemNameField: 'linkText',
                    fields: [
                        {
                            type: NICmsContentField.EFieldType.text,
                            key: 'linkText',
                            title: 'Link Text',
                            required: true
                        },
                        {
                            type: NICmsContentField.EFieldType.text,
                            key: 'url',
                            title: 'URL',
                            required: true
                        }
                    ]
                },
                {
                    type: NICmsContentField.EFieldType.toggle,
                    key: 'displayButtton',
                    title: 'Display Button',
                    default: false,
                    labels: {
                        true: 'Yes',
                        false: 'No'
                    }
                }
            ],
            default: [
                {
                    title: 'Stock Level Report - csv',
                    displayButtton: true
                }
            ]
        }
    ]
})
export class AccountStockLevelReportComponent extends UiComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NStockLevelComponent.IComponentData;

    private app = inject(App);

    get mediaFeedUrl() {
        return this.app.dfConfig.endpoint.mage + '/media/feed/' + this.app.dfConfig.ms.siteId + '_stock.csv';
    }
}
